import { render, staticRenderFns } from "./LabelUnitWrapper.vue?vue&type=template&id=56cc6c0b&scoped=true&"
import script from "./LabelUnitWrapper.vue?vue&type=script&lang=ts&"
export * from "./LabelUnitWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./LabelUnitWrapper.vue?vue&type=style&index=0&id=56cc6c0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc6c0b",
  null
  
)

export default component.exports